module.exports = __webpack_public_path__ + "static/media/SPC_02.7a4a57e0.jpeg";